// Pakistani cities list (synced from mobile app EnhancedDropdownData)
// Sorted alphabetically

export const pakistaniCities = [
  // Major Cities
  "Abbottabad",
  "Arifwala",
  "Astore",
  "Bahawalpur",
  "Bannu",
  "Bhakkar",
  "Bagh AJK",
  "Badin",
  "Charsadda",
  "Chaman",
  "Chiniot",
  "Chishtian",
  "Dadu",
  "Dera Ghazi Khan",
  "Dera Ismail Khan",
  "Diamer",
  "Faisalabad",
  "Ghizer",
  "Ghotki",
  "Gilgit",
  "Gujranwala",
  "Gujrat",
  "Gwadar",
  "Hafizabad",
  "Hala",
  "Haripur",
  "Hassan Abdal",
  "Hunza",
  "Hyderabad",
  "Islamabad",
  "Jacobabad",
  "Jaranwala",
  "Jatoi",
  "Jhang",
  "Jhelum",
  "Kamoke",
  "Karachi",
  "Karak",
  "Kasur",
  "Kaswal",
  "Khanewal",
  "Khanpur",
  "Khairpur",
  "Khairpur Nathan Shah",
  "Khuzdar",
  "Kohat",
  "Kot Addu",
  "Kotli AJK",
  "Kotri",
  "Lahore",
  "Larkana",
  "Lodhran",
  "Loralai",
  "Mansehra",
  "Mandi Bahauddin",
  "Mardan",
  "Matiari",
  "Mianwali",
  "Mirpur",
  "Mirpur AJK",
  "Multan",
  "Muzaffarabad",
  "Muzaffargarh",
  "Nagar",
  "Narowal",
  "Nawabshah",
  "Nowshera",
  "Okara",
  "Pakpattan",
  "Pattoki",
  "Peshawar",
  "Pishin",
  "Quetta",
  "Rahim Yar Khan",
  "Rawalakot",
  "Rawalpindi",
  "Rohri",
  "Sadiqabad",
  "Sanghar",
  "Sargodha",
  "Shahdadpur",
  "Sheikhupura",
  "Shikarpur",
  "Shorkot",
  "Sialkot",
  "Sibi",
  "Skardu",
  "Sukkur",
  "Swat",
  "Tando Adam",
  "Tando Allahyar",
  "Thatta",
  "Toba Tek Singh",
  "Turbat",
  "Umerkot",
  "Vehari",
  "Wazirabad",
  "Zhob",
].sort((a, b) => a.localeCompare(b));


